/**
 * focus되어 있을 때 enter 입력 시 callback 실행
 * e.g. React Component에 onKeyDown={(event)=>pressEnter(event, callback) 추가
 * @param {ChangeEventHandler<T>} event
 * @param {function} callback
 */
export function pressEnter(event, callback) {
    if (event.keyCode === 13) { // Enter 입력
        callback();
    }
}

/**
 *
 * @param {string} value
 * @returns {boolean}
 */
export function isDate(value) {
    return typeof value === "string" && !isNaN(Date.parse(value)) && value.split("-").length === 3
}

/**
 * Date Validity check
 * @param {string} dateString
 * @returns {boolean}
 */
export function isValidDate(dateString) {
    let [year, month, date] = dateString.split("-").map(e => parseInt(e))
    if (!isDate(dateString))
        return false;
    let dateEnd = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (((year % 4 === 0) && (year % 100 !== 0)) || year % 400 === 0) {
        dateEnd[1] = 29;
    }
    if (month < 1 || month > 12)
        return false;
    month -= 1;
    return date <= dateEnd[month] && year >= 1900;
}

/**
 * \<input\>에서 최대 입력가능 글자 수 제한
 * e.g. input에 onChange={e => { limitInputNumber(e, limit) } 추가
 * @param {ChangeEventHandler<T>} event
 * @param {int} limit
 */
export function limitInputNumber(event, limit) {
    let value = event.target.value;
    if (value.length > limit)
        event.target.value = value.slice(0, limit);
}

/**
 * Date객체를 YYYY-mm-dd형식 string으로 변환. short=true일 경우 mm/dd형식으로 변환
 * @param {Date} date
 * @param {boolean} short
 * @returns {string} 날짜 문자열
 */
export function getDateString(date, short = false) {
    let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
    let shortDate = month + '-' + day;
    return short ? shortDate : date.getFullYear() + '-' + shortDate;
}

/**
 * Date객체를 YYYY-mm-dd HH24:II:SS 형으로 변환해서 리턴.
 * @param {Date} date
 * @returns {string} 날짜 문자열
 */
export function getFullTimeString(date) {
    let dateString = getDateString(date);
    let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return dateString + " " + hour + ":" + minute + ":" + second
}

/**
 * 전화번호 입력시 하이픈 붙은 형태로 리턴
 * @param {string} value
 * @returns {string} 하이픈이 붙은 전화번호
 */
export function phoneNumberWithHyphen(value) {
    if (!value) {
        return "";
    }

    value = value.replace(/[^0-9]/g, "");

    let result = [];
    let restNumber = "";

    // 지역번호와 나머지 번호로 나누기
    if (value.startsWith("02")) {
        // 서울 02 지역번호
        result.push(value.substring(0, 2));
        restNumber = value.substring(2);
    } else if (value.startsWith("1")) {
        // 지역 번호가 없는 경우
        // 1xxx-yyyy
        restNumber = value;
    } else {
        // 나머지 3자리 지역번호
        // 0xx-yyyy-zzzz
        result.push(value.substr(0, 3));
        restNumber = value.substring(3);
    }

    if (restNumber.length === 7) {
        // 7자리만 남았을 때는 xxx-yyyy
        result.push(restNumber.substring(0, 3));
        result.push(restNumber.substring(3));
    } else {
        result.push(restNumber.substring(0, 4));
        result.push(restNumber.substring(4));
    }

    return result.filter((val) => val).join("-");
}

/**
 * taget HTMLElemnt의 invalid 검사 후 원하는 위치에 오류 메시지 출력
 * @param {HTMLElement} target invalid 검사를 할 HTMLElement(e.g. \<input required\>)
 * @param {string} id 오류 메시지를 출력할 장소의 id
 * @param {string} message 오류 메시지
 */
export function setInvalidMessage(target, id, message) {
    if (target.validity.valid) {
        document.getElementById(id).innerHTML = "";
    } else {
        if (message === undefined || message === "") message = "잘못된 형식입니다.";
        document.getElementById(id).innerHTML = message;
    }
}

export function checkValidDateElementWithPattern(yearElement, monthElement, dayElement) {
    let regex1_31 = "0?[1-9]|[1-2][0-9]|3[01]"
    let regex1_30 = "0?[1-9]|[1-2][0-9]|30"
    let regex1_28 = "0?[1-9]|1[0-9]|2[0-8]"
    let regex1_29 = "0?[1-9]|[1-2][0-9]"

    let daysPerMonthRegex = [regex1_31, regex1_28, regex1_31, regex1_30, regex1_31, regex1_30, regex1_31, regex1_31, regex1_30, regex1_31, regex1_30, regex1_31]
    let daysForLeapYearRegex = regex1_29

    let validYear = yearElement.validity.valid;
    let validMonth = monthElement.validity.valid;
    if (validYear && validMonth) {
        let year = parseInt(yearElement.value);
        let month = parseInt(monthElement.value);
        let isLeap = year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
        if (month === 2 && isLeap)
            dayElement.pattern = daysForLeapYearRegex;
        else
            dayElement.pattern = daysPerMonthRegex[month - 1];
    }

    let validDay = dayElement.validity.valid
    return validYear && validMonth && validDay
}

/**
 * year와 month와 day의 id를 받아 valid를 판단,
 * year에 pattern="\d{4}" month에 pattern="0?[1-9]|1[0-2]"를 넣어두면 day에는 자동으로 pattern을 부여하여 validCheck 수행
 * @param {string} yearId year를 입력받는 HTML element의 id
 * @param {string} monthId month를 입력받는 HTML element의 id
 * @param {string} dayId day를 입력받는 HTML element의 id
 * @returns {boolean} valid이면 true
 */
export function checkValidDateWithPattern(yearId, monthId, dayId) {
    let regex1_31 = "0?[1-9]|[1-2][0-9]|3[01]"
    let regex1_30 = "0?[1-9]|[1-2][0-9]|30"
    let regex1_28 = "0?[1-9]|1[0-9]|2[0-8]"
    let regex1_29 = "0?[1-9]|[1-2][0-9]"

    let daysPerMonthRegex = [regex1_31, regex1_28, regex1_31, regex1_30, regex1_31, regex1_30, regex1_31, regex1_31, regex1_30, regex1_31, regex1_30, regex1_31]
    let daysForLeapYearRegex = regex1_29

    let validYear = document.getElementById(yearId).validity.valid;
    let validMonth = document.getElementById(monthId).validity.valid;
    if (validYear && validMonth) {
        let year = parseInt(document.getElementById(yearId).value);
        let month = parseInt(document.getElementById(monthId).value);
        let isLeap = year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
        if (month === 2 && isLeap)
            document.getElementById(dayId).pattern = daysForLeapYearRegex;
        else
            document.getElementById(dayId).pattern = daysPerMonthRegex[month - 1];
    }

    let validDay = document.getElementById(dayId).validity.valid
    return validYear && validMonth && validDay
}

/**
 * 모달의 헤더를 클릭하여 모달을 움직일 수 있게 해주는 함수
 * @param {MouseDownEventHandler<T>} e
 * @param {string} modalIdName 움직일 모달의 id
 */
export function moveModal(e, modalIdName) {
    if (e.target !== e.currentTarget) return;
    let startX = e.clientX
    let startY = e.clientY

    let onMove = (e) => {
        let lastX = startX - e.clientX
        let lastY = startY - e.clientY

        startX = e.clientX;
        startY = e.clientY;

        let modal = document.getElementById(modalIdName)
        modal.style.top = modal.offsetTop - lastY + "px";
        modal.style.left = modal.offsetLeft - lastX + "px";
    }

    let onRemoveEvent = () => {
        document.removeEventListener('mouseup', onRemoveEvent);
        document.removeEventListener('mousemove', onMove);
    }

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onRemoveEvent);
}

/**
 * 문자열의 총 byte 수를 계산
 * @param {string} str byte 검사할 문자열
 * @returns byte 길이
 */
export function getByteLength(str) {
    let length = 0;

    for (let i = 0; i < str.length; i++)
        length += (str.charCodeAt(i) > 128) ? 2 : 1;
    return length;
}

/**
 * 홀딩 기간을 일수로 계산합니다
 * @param {string} startDate - 시작일 (YYYY-MM-DD 형식)
 * @param {string} endDate - 종료일 (YYYY-MM-DD 형식)
 * @returns {number} 홀딩 기간 (일수)
 */
export function calculateHoldingDays(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
}